export default function flattenArrayUtil (array) {
  if (!Array.isArray(array)) {
    throw new Error('Expected an array')
  }

  return array.reduce((acc, val) => acc.concat(val), [])
}
